// extracted by mini-css-extract-plugin
export default {"accidents":"region-accidents_accidents__ohOeA","status":"region-accidents_status__GBCP+","actions":"region-accidents_actions__xfEWr","tabs":"region-accidents_tabs__4gIgv"};